import { findCleonContainers } from "../player/core/container-dom.js";
import {
  setupConsentBridge,
  listenToTCFChanges,
} from "../player/ads/consent-bridge.js";
import { createLogger, getDebugMode } from "../player/helpers/logger.js";

setupConsentBridge();
listenToTCFChanges();

let initModulePromise = null;

function loadContainerInit() {
  if (!initModulePromise) {
    initModulePromise = import("../player/core/container-init.js");
  }

  return initModulePromise;
}

function initContainer(container, index) {
  if (
    container.__cleonQueued ||
    container.__cleonInitialized ||
    container.__cleonInitializing
  ) {
    return;
  }

  container.__cleonQueued = true;

  const debug = getDebugMode(container);
  const log = createLogger(`Cleon:${index + 1}`, debug);

  log.debug("Queueing container initialization", {
    debug,
    containerId: container.id || null,
    zoneId:
      container.getAttribute("data-cleon-zone") ||
      container.getAttribute("data-videozoneid") ||
      null,
  });

  const start = async () => {
    try {
      const { initCleonContainer } = await loadContainerInit();

      await initCleonContainer(container, {
        debug,
        initReason: "eager",
      });
    } catch (error) {
      container.__cleonQueued = false;

      log.error("Cleon init failed", {
        error,
      });
    }
  };

  queueMicrotask(() => void start());
}

function bootCleon() {
  const containers = findCleonContainers();

  if (!containers.length) {
    return;
  }

  containers.forEach((container, index) => {
    initContainer(container, index);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootCleon, { once: true });
} else {
  bootCleon();
}